module.exports = __webpack_public_path__ + "media/packs/assets/images/concepts/ja/p2-9998ab1a3977f585deca4ded29425ac5.png";